import styled from '@emotion/styled';
import { ReactComponent as LogoutIcon } from './icon.svg';

export const SignOutIcon = styled(LogoutIcon)`
  width: 14px;
  height: 14px;
  margin-left: 10px;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
`;
